// usePermissionType.js
import useColors from "../../../../api/hooks/useColors";
import { ReactComponent as BlueAdmin } from "../../../../icons/icon_files/permissionBlue.svg";
import { ReactComponent as OrangeAdmin } from "../../../../icons/icon_files/permissionOrange.svg";
import { ReactComponent as PinkAdmin } from "../../../../icons/icon_files/permissionPink.svg";
import { ReactComponent as PurpleAdmin } from "../../../../icons/icon_files/permissionPurple.svg";
import { ReactComponent as LightBlueAdmin } from "../../../../icons/icon_files/permissionSecondary.svg";
import { ReactComponent as YellowAdmin } from "../../../../icons/icon_files/permissionYellow.svg";

const usePermissionType = () => {
  const colors = useColors();

  const getPermissionType = (permissionType, category) => {
    if (!permissionType) {
      return {
        icon: null,
        borderColor: colors.text_secondary,
        permissionLabel: "Admin",
      };
    }
    const permissionTypes = {
      "Resource Admin": {
        icon: BlueAdmin,
        borderColor: colors.primary_light,
        permissionLabel: permissionType,
      },
      "Super Admin": {
        icon: LightBlueAdmin,
        borderColor: colors.secondary_main,
        permissionLabel: permissionType,
      },
      "User Admin": {
        icon: OrangeAdmin,
        borderColor: colors.warning_main,
        permissionLabel: permissionType,
      },
      "Organization Admin": {
        icon: PinkAdmin,
        borderColor: colors.error_light,
        permissionLabel: permissionType,
      },
      "Security Admin": {
        icon: PurpleAdmin,
        borderColor: colors.info_main,
        permissionLabel: permissionType,
      },
      Owner: {
        icon: YellowAdmin,
        borderColor: colors.warning_light,
        permissionLabel: permissionType,
      },
      DEFAULT: {
        icon: YellowAdmin,
        borderColor: colors.warning_light,
        permissionLabel: permissionType,
      },
    };
    return (
      permissionTypes[category] || {
        icon: LightBlueAdmin,
        borderColor: colors.text_secondary,
        permissionLabel: "Admin",
      }
    );
  };

  return getPermissionType;
};

export default usePermissionType;
